import { useEffect, useState, useCallback } from "react";
import { getIgSettings, setIgSettings, testIgSettings, refreshIgToken } from "../../lib/api";
import { toast } from "sonner";

const EMPTY_STATE = {
  connected: false, token_masked: "", ig_user_id: "", connected_username: "", verified_at: "",
  app_id: "", has_app_secret: false, expires_at: "", days_left: null, refresh_error: "",
};
const EMPTY_FORM = { token: "", igUserId: "", appId: "", appSecret: "" };

export function useIgSettings() {
  const [state, setState] = useState(EMPTY_STATE);
  const [form, setForm] = useState(EMPTY_FORM);
  const [busy, setBusy] = useState(false);

  const load = useCallback(() => getIgSettings()
    .then((d) => { setState(d); setForm((f) => ({ ...f, igUserId: d.ig_user_id || "", appId: d.app_id || "" })); })
    .catch((e) => console.warn("instagram settings load failed", e)), []);
  useEffect(() => { load(); }, [load]);

  const setField = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const guarded = async (fn) => {
    setBusy(true);
    try { await fn(); } finally { setBusy(false); }
  };

  const save = () => {
    if (!form.igUserId.trim()) { toast.error("Inserisci l'IG User ID"); return; }
    if (!form.token.trim() && !state.connected) { toast.error("Inserisci l'Access Token"); return; }
    return guarded(async () => {
      try {
        const d = await setIgSettings({ access_token: form.token, ig_user_id: form.igUserId, app_id: form.appId, app_secret: form.appSecret });
        setState(d); setForm((f) => ({ ...f, token: "", appSecret: "" }));
        toast.success("Credenziali Instagram salvate");
      } catch { toast.error("Errore nel salvataggio"); }
    });
  };

  const test = () => guarded(async () => {
    try {
      const d = await testIgSettings();
      toast.success(`Collegato a @${d.username}`);
      load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Test fallito"); }
  });

  const refresh = () => guarded(async () => {
    try {
      const d = await refreshIgToken();
      setState(d);
      toast.success(`Token rinnovato, scade il ${(d.expires_at || "").slice(0, 10)}`);
    } catch (e) { toast.error(e?.response?.data?.detail || "Rinnovo fallito"); load(); }
  });

  const disconnect = () => guarded(async () => {
    try {
      const d = await setIgSettings({ access_token: "", ig_user_id: "" });
      setState(d); setForm(EMPTY_FORM);
      toast.success("Instagram scollegato");
    } catch { toast.error("Errore"); }
  });

  return { state, form, setField, busy, save, test, refresh, disconnect };
}
